<template>
  <div>
      <div class="text-center" v-if="items.length === 0">
        <v-icon color="grey" large> {{icon}} </v-icon>
        <p class="ma-0 py-2 grey--text"> {{emptyMessage}} </p>
      </div>
      <template v-else>
        <v-divider></v-divider>
        <div style="min-height:470px;">
        <v-list class="pt-0" three-line>
          <template v-for="(item, i) in paginatedItems">
            <lista-sucursal-item
              text="Estado: "
              :item="item"
              :key="i"
              :index="i"
              :icon="icon"
              v-if="type === 'offices'"
              @selected="selectItem"
              @delete="deleteItem"
            ></lista-sucursal-item>
            <v-divider :key="i +'a'"></v-divider>
          </template>
        </v-list>
        </div>
        <div class="text-center">
          <v-pagination
            v-model="page"
            :length="totalPages"
          ></v-pagination>
        </div>
      </template>
      <modal-sucursal @saved="$emit('saved')" ref="modalSucursal" />
    <kimsa-confirm
      ref="deleteConfirmDialog"
      title="Eliminar Sucursal"
      content="¿Confirmas que deseas eliminar esta sucursal?"
      @confirm="confirmDelete"
      :loading="deleting"
    />
  </div>
</template>
<script>
import ListaUsuarioItem from '@/components/providers/panel/ListaUsuarioItem'
import ListaSucursalItem from '../../../components/providers/panel/ListaSucursalItem'
import ModalSucursal from '../../../components/providers/panel/ModalSucursal'
import ModalUsuario from '@/components/providers/panel/ModalUsuario'
import KimsaConfirm from "../../common/KimsaConfirm";
export default {
  props: {
    title: {
      type: String,
      default: 'Título'
    },
    color: {
      type: String,
      default: 'primary'
    },
    items: {
      type: Array,
      default: () => []
    },
    icon: {
      type: String,
      default: 'fas fa-user-circle'
    },
    type: { // users - offices
      type: String,
      required: true
    },
    paginacion: {
      type: Number,
      default: 5
    },
    emptyMessage: {
      type: String,
      default: 'No hay items a visualizar'
    },
    sucursales: {
      type: Array,
      default: () => []
    },
    roles: {
      type: Array,
      default: () => []
    }
  },
  components: {
    KimsaConfirm,
    ListaUsuarioItem,
    ListaSucursalItem,
    ModalSucursal,
    ModalUsuario
  },
  data() {
    return {
      page: 1,
      itemToDelete: null,
      deleting: false,
    }
  },
  methods:{
    deleteItem(item){
      const vm = this
      vm.itemToDelete = item
      vm.$refs.deleteConfirmDialog.show()
    },
    async confirmDelete(){
      const vm = this
      if(!vm.itemToDelete) return
      vm.deleting = true
      const deleted = await this.$store.dispatch('branches/deleteBranch', this.itemToDelete)
      vm.deleting = false
      if (deleted){
        this.$emit('cerrar')
        vm.toast('Sucursal eliminada correctamente')
        vm.$refs.deleteConfirmDialog.hide()
        vm.itemToDelete = null
      }else{
        vm.toast('Ocurrió un error', 'error')
      }
      vm.$emit('deleted')
    },
    selectItem(item){
      const vm = this
      vm.$refs.modalSucursal.show(item)
    }
  },
  watch: {
    modal: function(val) {
      if (val)
        setTimeout(() => {
          this.$refs.modalSucursal.editing = false
          this.$refs.modalSucursal.setItem()
        }, 50)
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.items.length / this.paginacion)
    },
    paginatedItems() {
      const inicial = (this.page - 1) * this.paginacion
      const final = this.paginacion + (this.paginacion * (this.page - 1))
      return this.items.slice(inicial, final)
    }
  }
}
</script>
<style scoped>
.listado {
  max-height: 300px;
  overflow-y: scroll;
}
/* width */
::-webkit-scrollbar {
    width: 9px;
    height: 4px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #000;
    border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: rgb(15, 105, 189);
    border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: rgb(209, 209, 209);
}
</style>



